import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'; // Importando o React Router
// import jwtDecode from 'jwt-decode';
import { AUTH_USER_POOL_SECRET, AUTH_USER_POOL_WEB_CLIENT_ID, REACT_APP_AUTH_DOMAIN_NAME } from '../../utils/config/configs';
import { getTenantConfig } from '../../utils/config/tenantConfig';
import { useAuthContext } from '../../contexts/AuthContext';
import { jwtDecode } from 'jwt-decode';

const Callback = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const { fetchUser } = useAuthContext();

    useEffect(() => {
        // Captura o código da URL
        const queryParams = new URLSearchParams(location.search);
        const code = queryParams.get('code');

        if (code) {
            // Se o código estiver presente, troque-o por tokens
            exchangeCodeForToken(code);
        } else {
            console.error("Código de autorização não encontrado na URL");
            navigate('/login');
        }
    }, [location]);

    const exchangeCodeForToken = async (authCode) => {
        try {
            const tenantConfig = getTenantConfig();
            const authDomain = 'https://' + REACT_APP_AUTH_DOMAIN_NAME;

            const params = new URLSearchParams();
            params.append("grant_type", "authorization_code");
            params.append("client_id", AUTH_USER_POOL_WEB_CLIENT_ID);
            params.append("code", authCode);
            params.append("redirect_uri", tenantConfig.redirectSignIn);

            // const body = new URLSearchParams(params).toString();
            const authHeader = `Basic ${btoa(`${AUTH_USER_POOL_WEB_CLIENT_ID}:${AUTH_USER_POOL_SECRET}`)}`;

            const response = await fetch(`${authDomain}/oauth2/token`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    Authorization: authHeader,
                },
                body: params.toString(),
            });

            if (!response.ok) {
                const errorDetails = await response.json();
                console.error("Error details:", errorDetails);
                throw new Error("Failed to exchange authorization code for token");
            }

            const tokens = await response.json();

            // Salvar tokens no localStorage
            localStorage.setItem("mico_token", tokens.access_token);
            localStorage.setItem("mico_refreshToken", tokens.refresh_token);
            const decoded_id_token = jwtDecode(tokens.id_token);

            if(tokens.refresh_token) {
                localStorage.setItem('mico_refreshToken', tokens.refresh_token);
            } else {
                localStorage.setItem('mico_loginType', 'AD');
            }

            fetchUser(decoded_id_token);
        } catch (error) {
            console.error("Error during OIDC callback:", error);
        }
    };
};

export default Callback;